import React, { Component } from "react";

class GolfStatusLogUpdateSlot extends Component {
  render() {
    console.log("Hello from GolfStatusLogUpdate. We are processing counter: "+this.props.counter)
    return (
            <tr>
                <td>{this.props.user}</td>
                <td>{this.props.zone.name}</td>
                <td>{this.props.zone.slots[this.props.counter].FL}</td>
                <td>{this.props.zone.slots[this.props.counter].sh}</td>
                <td>{this.props.zone.slots[this.props.counter].sm}</td>
                <td>{this.props.zone.slots[this.props.counter].eh}</td>
                <td>{this.props.zone.slots[this.props.counter].em}</td>
            </tr>
    );
  }
}

export default GolfStatusLogUpdateSlot;
